import wobble from '../elements/wobble.js';
wobble.register();
